import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
   selector: 'samweb-confirm-dialog',
   templateUrl: './confirm-dialog.component.html',
   styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
   @Input()
   public displayedText = '';

   @Output()
   public confirm = new EventEmitter();

   @Output()
   public cancel = new EventEmitter();

   constructor() {}

   ngOnInit(): void {}

   onConfirm() {
      this.confirm.emit();
   }

   onCancel() {
      this.cancel.emit();
   }
}
